import { Injectable } from "@angular/core";

import { AppState } from "../../core/app-state";

import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { RestClient } from "../../core/services/rest-client";
import { VolunteerPointViewRecord } from "../models/volunteer-point-record";
import { Building } from "../../core/models";

@Injectable({ providedIn: "root" })
export class VolunteerPointViewService extends RestClient<VolunteerPointViewRecord> {
  constructor(public appState: AppState, http: HttpClient) {
    super(http, "volunteerPointView", appState);
  }

  async findAvailableBuildings() {
    try {
      const result: any = await firstValueFrom(
        this.http.get(`${this.urlPath}/findAvailableBuildings`)
      );
      const resp: Building[] = result.data;
      console.dir(resp);
      return resp;
    } catch (error) {
      console.error("findAvailableBuildings() error: " + error?.message);
      throw error;
    }
  }
}
